import { DateTime } from 'luxon';
import { PaymentMethodConfig, PaymentMethodStatus, PaymentMethodConfigType, StripeAccount } from './payment-config';

export namespace PaymentConfigParsers {
  export class StripeAccountJson {
    userId!: number;
    accountStatus!: number;
    accountType!: string;
    businessEmail!: string;
    businessName!: string;
    stripeAccountId!: string;
    createdAt!: DateTime;
    updatedAt!: DateTime;
    missingRequirements?: string[];
  }

  export function toStripeAccount(input: StripeAccountJson): StripeAccount {
    return { ...input };
  }

  export type PaymentMethodJson = {
    id: string;
    name: string;
    displayName: string;
    description: string;
    status: string;
    type: string;
    createdAt: DateTime;
    deletedAt?: DateTime;
  };

  export function toPaymentMethod(input: PaymentMethodJson): PaymentMethodConfig {
    return {
      ...input,
      status: input.status as PaymentMethodStatus,
      type: input.type as PaymentMethodConfigType,
    };
  }
}
